import { API } from '@/api'

export const loginPost = data => API.post('/login/', data)
export const logout = () => API.post('/logout/')
